<template>
  <NewImageBox
    :src="data.file.url"
    :width="imageSize.width"
    :height="imageSize.height"
    :alt="data.caption"
    :max-width="imageSize.width"
    :image-params="imageParameters"
    center-image
  />
</template>

<script>
import NewImageBox from '@/components/NewImageBox';

export default {
  name: 'EditorImage',
  components: {
    NewImageBox,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    // TODO: obliczenia dla wysokości
    imageSize() {
      let width = Number(this.data.file.width);
      let height = Number(this.data.file.height);
      const heightRatio = height / width;
      const widthRatio = width / height;

      if (this.data.imageMaxWidth) {
        width = Number(this.data.imageMaxWidth);
        height = Math.ceil(heightRatio * width);
      }

      if (width > 820) {
        width = 820;
        height = Math.ceil(heightRatio * width);
      }

      if (height > 800) {
        height = 800;
        width = Math.ceil(widthRatio * height);
      }

      return {
        width,
        height,
      };
    },
    imageParameters() {
      if (this.data.imageMaxWidth) {
        return Number(this.data.imageMaxWidth) > Number(this.data.file.width)
          ? `w_${this.data.file.width ? this.data.file.width : '820'},h_800`
          : `w_${this.data.imageMaxWidth},h_800`;
      } else {
        return 'w_820,h_800';
      }
    },
  },
};
</script>
